import { useConfirmModal } from 'app/useConfirmModal'
import { deleteObject } from 'data/hooks/objects/objectOperations'
import { refetchObjects } from 'data/hooks/objects/refetchObjects'
import { getIsStackerNativeObject } from 'features/admin/stackerNativeObjectUtils'

import { Modal } from 'v2/ui/utils/useModalToggle'

import { useToast } from 'ui/components/Toast'

import { getDeleteTableModalData } from './utils'

export function useConfirmDeleteTableModal(object?: ObjectDto) {
    const toast = useToast()

    const deleteTableModalData = getDeleteTableModalData(object)

    const { show: showConfirm, setData } = useConfirmModal({
        ...deleteTableModalData,
        onConfirm: async (modal: Modal<unknown>) => {
            if (!object) return

            setData({ ...deleteTableModalData, isSaving: true })
            try {
                await deleteObject(object?._sid)
                await refetchObjects()

                modal.toggle()
            } catch (err) {
                console.error(err)
                toast({
                    type: 'error',
                    title: 'There was a problem deleting the table',
                    startIcon: { name: 'AlertCircle' },
                    helperText: 'Please try again later. If the issue persists, contact support.',
                })
            } finally {
                setData({ ...deleteTableModalData, isSaving: false })
            }
        },
    })

    const canDelete = getIsStackerNativeObject(object)

    return {
        showModal: showConfirm,
        canDelete,
    }
}
